import { useMemo } from 'react';

import { ACTION_OBJECT_TYPES } from 'actions/useActionsLibrary';

import PageHeader from 'components/global/PageHeader';
import DynamicList from 'components/list/DynamicList';
import { FilterType } from 'components/list/DynamicListFilterUtils';

import { BRAND } from 'services/consts';

import { DYNAMICLISTS } from 'utils/constants';

const BMInventoryList = () => {
	const columns = useMemo(
		() => [
			{ Header: 'id', accessor: 'id', filterType: FilterType.number, show: false },
			{ Header: 'warehouseName', accessor: 'warehouseName', filterType: FilterType.string },

			{
				Header: 'branchName',
				accessor: 'branchName',
				filterType: FilterType.string
			},

			{ Header: 'product', accessor: 'name', filterType: FilterType.string },
			{
				Header: 'price',
				accessor: 'price',
				filterType: FilterType.number
			},
			{
				Header: 'storeName',
				accessor: 'brandName',
				filterType: FilterType.multiSelection
			},
			{
				Header: 'sku',
				accessor: 'sku',
				filterType: FilterType.string
			},
			{
				Header: 'qtyOnHand',
				accessor: 'quantityOnHand',
				filterType: FilterType.number
			},
			{
				Header: 'qtyForecasted',
				accessor: 'quantityForecasted',
				filterType: FilterType.number
			},
			{
				Header: 'binQty',
				accessor: 'binQty',
				filterType: FilterType.number,
				roleName: 'WMS_BinTracking'
			},
			{
				Header: 'minInventory',
				accessor: 'minInventory',
				filterType: FilterType.string
			},
			{
				Header: 'maxInventory',
				accessor: 'maxInventory',
				filterType: FilterType.string
			}
		],
		[]
	);

	return (
		<div>
			<PageHeader
				title="inventory"
				lordIcon={
					'https://storage.googleapis.com/tryoto-public/lordicon-compressed/outline/inventory-icon.json.gz'
				}
			/>
			<DynamicList
				id={DYNAMICLISTS.BM_INVENTORY}
				columns={columns}
				fetchUrl={BRAND.GET_BRAND_INVENTORY_LIST}
				actionObjectType={ACTION_OBJECT_TYPES.INVENTORY}
				exportName="inventory"
			/>
		</div>
	);
};

export default BMInventoryList;
